import './Skeleton.less';

export const prefix = 'oc-c-skeleton';

export { default } from './Skeleton';